<div class="container-fluid">
  <div class="row">
    <div class="col-lg-6">
      @if (!bathroom) {
        <h2 mat-dialog-title>Add Bathroom</h2>
      }
    </div>
    <div class="col-lg-6">
      @if (!bathroom) {
        <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
          <mat-icon>close</mat-icon>
        </button>
      }
    </div>
  </div>
  <div class="row">
    <div class="col-lg-12">
      <mat-dialog-content class="p-0 m-0">
        <mat-tab-group>
          <div class="row">
            <div class="col-lg-12">
              <mat-tab label="Details">
                <div [formGroup]="form1">
                  <div class="row">
                    @if (formAlert) {
                      <div class="col-12">
                        <div class="block" style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                          <p><b>{{formAlert}}</b></p>
                        </div>
                      </div>
                    }
                    <div class="col-6">
                      <mat-form-field class="block">
                        <mat-label>Name</mat-label>
                        <mat-select [(value)]="form1.value.name" formControlName="name">
                          @for (stat of bathroomNames; track stat) {
                            <mat-option [value]="stat.value"> {{stat.name}} </mat-option>
                          }
                        </mat-select>
                        @for (validation of validationMessages.name; track validation) {
                          <mat-error>
                            @if (form1.get('name').hasError(validation.type) && (form1.get('name').dirty || form1.get('name').touched)) {
                              <mat-error class="error-message">
                              {{validation.message}}</mat-error>
                            }
                          </mat-error>
                        }
                      </mat-form-field>
                    </div>
                    <div class="col-6">
                      <mat-form-field class="block">
                        <mat-label>Type</mat-label>
                        <mat-select [(value)]="form1.value.bathroomType" formControlName="bathroomType">
                          @for (stat of bathroomTypes; track stat) {
                            <mat-option [value]="stat.value"> {{stat.name}} </mat-option>
                          }
                        </mat-select>
                        @for (validation of validationMessages.bathroomType; track validation) {
                          <mat-error>
                            @if (form1.get('bathroomType').hasError(validation.type) && (form1.get('bathroomType').dirty || form1.get('bathroomType').touched)) {
                              <mat-error class="error-message">
                              {{validation.message}}</mat-error>
                            }
                          </mat-error>
                        }
                      </mat-form-field>
                    </div>
                    <div class="col-6">
                      <mat-form-field class="block">
                        <mat-label>Access</mat-label>
                        <mat-select [(value)]="form1.value.accessVia" formControlName="accessVia">
                          @for (stat of accessVias; track stat) {
                            <mat-option [value]="stat.value"> {{stat.name}} </mat-option>
                          }
                        </mat-select>
                        @for (validation of validationMessages.accessVia; track validation) {
                          <mat-error>
                            @if (form1.get('accessVia').hasError(validation.type) && (form1.get('accessVia').dirty || form1.get('accessVia').touched)) {
                              <mat-error class="error-message">
                              {{validation.message}}</mat-error>
                            }
                          </mat-error>
                        }
                      </mat-form-field>
                    </div>
                    <div class="col-3">
                      <mat-slide-toggle class="block" formControlName="showerDisabledAccess">Shower Disabled Access</mat-slide-toggle>
                    </div>
                    <div class="col-3">
                      <mat-slide-toggle class="block" formControlName="tubDisabledAccess">Tub Disabled Access</mat-slide-toggle>
                    </div>
                    <div class="col-12">
                      <mat-form-field class="block">
                        <mat-label>General Description</mat-label>
                        <textarea matInput formControlName="description" readonly="{{formReadOnly}}" matTextareaAutosize matAutosizeMinRows="5" matAutosizeMaxRows="500"
                        matTooltip="Enter description, paragrphs are ok."></textarea>
                        @for (validation of validationMessages.description; track validation) {
                          <mat-error>
                            @if (form1.get('description').hasError(validation.type) && (form1.get('description').dirty || form1.get('description').touched)) {
                              <mat-error class="error-message">
                                {{validation.message}}
                              </mat-error>
                            }
                          </mat-error>
                        }
                      </mat-form-field>
                    </div>
                    <div class="col-12">
                      <mat-form-field class="block">
                        <mat-label>Amenities Desc</mat-label>
                        <textarea matInput formControlName="consumablesDesc" readonly="{{formReadOnly}}" matTextareaAutosize matAutosizeMinRows="5" matAutosizeMaxRows="500"
                        matTooltip="Enter consumablesDesc, paragrphs are ok."></textarea>
                        @for (validation of validationMessages.consumablesDesc; track validation) {
                          <mat-error>
                            @if (form1.get('consumablesDesc').hasError(validation.type) && (form1.get('consumablesDesc').dirty || form1.get('consumablesDesc').touched)) {
                              <mat-error class="error-message">
                                {{validation.message}}
                              </mat-error>
                            }
                          </mat-error>
                        }
                      </mat-form-field>
                    </div>
                    <div class="col-12">
                      <div class="block">
                        @if (bathroomId) {
                          <button style="float:left;" mat-raised-button color="error" (click)="formDelete()" [disabled]="!form1.valid">Delete Bathroom</button>
                        }
                        @if (bathroomId) {
                          <button style="float:right;" mat-raised-button color="primary" (click)="formUpdate()" [disabled]="!form1.valid">Update Bathroom</button>
                        }
                        @if (!bathroomId) {
                          <button style="float:right;" mat-raised-button color="primary" (click)="formAdd()" [disabled]="!form1.valid">Add Bathroom</button>
                        }
                        @if (!bathroomId) {
                          <button style="float:left;" mat-raised-button [mat-dialog-close]="true">Done</button>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </mat-tab>
            </div>
            <div class="col-lg-12">
              @if (bathroom) {
                <div>
                  <mat-tab label="Features">
                    <div class="row">
                      <ng-template matTabContent>
                        <div class="col-lg-12">
                          <div class="row">
                            <div class="col-lg-12">
                              <app-feature-list class="block" [featuresList]="featuresList" title="Lead Bath Features" [shortTermRentalId]="shortTermRentalId" featureType="bathroomLeadFeature"
                                describesType="{{bathroom.name}}">
                              </app-feature-list>
                            </div>
                            <br><br>
                            <div class="col-lg-12">
                              <app-feature-list class="block" [featuresList]="featuresList" title="Bathroom Type" [shortTermRentalId]="shortTermRentalId" featureType="bathroomType" describesType="{{bathroom.name}}">
                              </app-feature-list>
                            </div>
                            <br><br>
                            <div class="col-lg-12">
                              <app-feature-list class="block" [featuresList]="featuresList" title="Amenities" [shortTermRentalId]="shortTermRentalId" featureType="bathroomAmenity" describesType="{{bathroom.name}}">
                              </app-feature-list>
                            </div>
                            <br><br>
                            <div class="col-lg-12">
                              <app-feature-list class="block" [featuresList]="featuresList" title="Linens" [shortTermRentalId]="shortTermRentalId" featureType="bathroomLinens" describesType="{{bathroom.name}}">
                              </app-feature-list>
                            </div>
                            <br><br>
                            <div class="col-lg-12">
                              <app-feature-list class="block" [featuresList]="featuresList" title="Features" [shortTermRentalId]="shortTermRentalId" featureType="bathroomFeature" describesType="{{bathroom.name}}">
                              </app-feature-list>
                            </div>
                            <br><br>
                            <div class="col-lg-12">
                              <app-feature-list class="block" [featuresList]="featuresList" title="Shower" [shortTermRentalId]="shortTermRentalId" featureType="bathroomShower" describesType="{{bathroom.name}}">
                              </app-feature-list>
                            </div>
                            <br><br>
                            <div class="col-lg-12">
                              <app-feature-list class="block" [featuresList]="featuresList" title="Sink" [shortTermRentalId]="shortTermRentalId" featureType="bathroomSink" describesType="{{bathroom.name}}">
                              </app-feature-list>
                            </div>
                            <br><br>
                            <div class="col-lg-12">
                              <app-feature-list class="block" [featuresList]="featuresList" title="Toilet" [shortTermRentalId]="shortTermRentalId" featureType="bathroomToilet" describesType="{{bathroom.name}}">
                              </app-feature-list>
                            </div>
                            <br><br>
                            <div class="col-lg-12">
                              <app-feature-list class="block" [featuresList]="featuresList" title="Tub" [shortTermRentalId]="shortTermRentalId" featureType="bathroomTub" describesType="{{bathroom.name}}">
                              </app-feature-list>
                            </div>
                            <br><br>
                            <div class="col-lg-12">
                              <app-feature-list class="block" [featuresList]="featuresList" title="Access" [shortTermRentalId]="shortTermRentalId" featureType="bathroomAccess" describesType="{{bathroom.name}}">
                              </app-feature-list>
                            </div>
                          </div>
                        </div>
                      </ng-template>
                    </div>
                  </mat-tab>
                </div>
              }
            </div>
          </div>
        </mat-tab-group>

      </mat-dialog-content>
    </div>
  </div>
</div>